<template>
	<div class="w-100">
		<template v-if="design_type == '1'">
			<div class="row bold-shadow-2 slim-grid-row my-3 pb-2 menu-1">
		    <div class="col-6" @click="toggleDetail">
		    	<div class="position-relative">
			      <img
              :src="data.image_url"
              :class="{'grayscale' : !data.openTime.available}"
			        class="w-100 rounded object-fit img-height-menu"
			        style="height: 180px;"
			      />
            <template v-if="data.openTime.available">
              <p class="mb-0 badge-variant body-3-3 text-white" v-if="is_variant">{{data.variant_list.length}} {{$pluralWord(data.variant_list.length,'variant')}}</p>
              <!-- DELIVERY -->
              <template v-if="isDelivery">
                <p :id="`delivery-product-${data.id}`" class="bg-white py-1 px-2 rounded body-3-1 position-absolute mb-0" style="right: 10px;top: 10px;">
                  <img src="../../assets/img/icon/fast-delivery.png" width="24">
                </p>
                <b-tooltip :target="`delivery-product-${data.id}`" placement="top" title="Available for delivery">
                </b-tooltip>
              </template>
            </template>
		    	</div>
		    </div>
		    <div class="col-6">
		    	<div class="w-100" @click="toggleDetail">
			      <p class="mb-0 mt-1 body-15 text-black text-truncate">{{ data.name }}</p>
			      <div class="menu-list-desc">
			        <p class="mb-0 text-14 text-light-menu">{{ data.description }}</p>
			      </div>
			      <div v-if="is_decrease_promo" class="position-relative" style="height:18px;top: -1px;">
			        <p
			          class="mb-0 ls-0-1 text-14 text-line-through d-inline-block text-light-menu"
			        >{{formatCurrency(promotion_price)}}</p>
			      </div>
			      <p
			        class="mb-0 body-2-2 text-truncate d-inline-block text-color-orange font-semibold position-relative text-15"
			        style="top: 7px"
			      >{{ formatCurrency(final_price) }}</p>
			      <div v-if="!is_decrease_promo" class="w-100" style="height:18px;top: -1px;"></div>
			    </div>
		      <div class="position-relative top-menu-list" style="top: 11px;">
            <template v-if="data.openTime.available">
              <div v-if="!is_variant && qtyCart > 0" class="ml-auto" style="width: 120px;">
                <div class="row no-gutters">
                  <div class="col-4 align-self-center">
                    <div class="pos-order-qty bg-orange" @click="changeQtyProduct('minus')">
                      <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1.71429H0V0H12V1.71429Z" fill="white" />
                      </svg>
                    </div>
                  </div>
                  <div class="col-4 align-self-center text-center">
                    <p class="mb-0 font-lato text-14">{{ qtyCart  }}</p>
                  </div>
                  <div class="col-4 align-self-center">
                    <div class="pos-order-qty bg-orange ml-auto" @click="changeQtyProduct('plus')">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- BTN ONLY -->
              <template v-if="!getMerchant().is_preview_only">
                <template v-if="btn_design_type == '1'">
                  <button
                    v-if="qtyCart == 0 || is_variant"
                    class="btn bg-orange font-bold text-12 py-1 text-white px-3 ls-1 float-right add-cart-list"
                    @click="changeQtyProduct('plus')"
                  >{{ $t("restaurant.add-to-cart") }}</button>
                  <p
                    v-if="qtyCart > 0 && is_variant"
                    class="mb-0 body-2 text-green mr-2 float-right"
                    style="margin-top: 5px;"
                  >({{qtyCart}}x)</p>
                </template>
                <template v-else>
                  <div class="d-block text-right">
                    <p
                      v-if="qtyCart > 0 && is_variant"
                      class="mb-0 body-2 text-green mr-2 d-inline-block align-middle"
                      style="margin-top: 5px;"
                    >({{qtyCart}}x)</p>
                    <button
                      v-if="qtyCart == 0 || is_variant"
                      class="btn bg-orange add-cart-list-3 d-inline-block align-middle"
                      @click="changeQtyProduct('plus')">
                      <img class="align-baseline" src="../../assets/img/icon/plus-2.png" width="15" />
                    </button>
                  </div>
                </template>
              </template>
            </template>
            <button
              v-else
              @click="toggleDetail"
              class="btn bg-light font-bold text-12 py-1 text-dark px-3 ls-1 float-right add-cart-list border-form"
            >Not Yet Available</button>
		      </div>
		    </div>
		  </div>
		</template>

		<template v-if="design_type == '2'">
			<div class="row slim-grid-row bold-shadow-2 my-3 rounded-6 py-2 menu-2">
		    <div class="col-3" @click="toggleDetail">
		    	<div class="position-relative">
			      <img :src="data.image_url" :class="{'grayscale' : !data.openTime.available}" class="w-100 rounded-6 img-list-2 object-fit w-100" />
			      <p class="mb-0 badge-variant body-3-3 text-white" v-if="is_variant && data.openTime.available">{{data.variant_list.length}} {{$pluralWord(data.variant_list.length,'variant')}}</p>
			    </div>
		    </div>
		    <div class="col-9">
          <div class="w-100 position-relative">
            <p @click="toggleDetail" class="mb-0 body-2 text-black text-truncate w-75">{{ data.name }}</p>
            <div @click="toggleDetail" style="height: 21px;">
              <p class="mb-0 text-14 text-light-menu text-truncate" v-if="data.description">{{ data.description }}</p>
            </div>
            <div class="d-flex justify-content-between align-items-end">
              <div @click="toggleDetail">
                <div style="height: 21px">
                  <p
                    class="mb-0 ls-0-1 text-14 text-line-through text-light-menu mr-2"
                    v-if="is_decrease_promo"
                  >{{ formatCurrency(promotion_price) }}</p>
                </div>
                <p
                  class="mb-0 body-2-2 text-truncate d-inline-block text-color-orange font-semibold"
                >{{ formatCurrency(final_price) }}</p>
              </div>
              <div class="pb-2">
                <template v-if="data.openTime.available">
                  <template v-if="!getMerchant().is_preview_only">
                    <div v-if="!is_variant && qtyCart > 0" class="ml-auto" style="width: 120px;">
                      <div class="row no-gutters">
                        <div class="col-4 align-self-center">
                          <div class="pos-order-qty bg-orange" @click="changeQtyProduct('minus')">
                            <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 1.71429H0V0H12V1.71429Z" fill="white" />
                            </svg>
                          </div>
                        </div>
                        <div class="col-4 align-self-center text-center">
                          <p class="mb-0 font-lato text-14">{{ qtyCart  }}</p>
                        </div>
                        <div class="col-4 align-self-center">
                          <div class="pos-order-qty bg-orange ml-auto" @click="changeQtyProduct('plus')">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <button
                       v-if="btn_design_type == '1' && (qtyCart == 0 || is_variant)"
                      class="btn bg-orange font-bold text-12 py-1 text-white px-3 ls-1 float-right mt-3"
                      @click="changeQtyProduct('plus')"
                    >{{ $t("restaurant.add-to-cart") }}</button>
                    <button
                      v-if="btn_design_type == '2' && (qtyCart == 0 || is_variant)"
                      class="btn mt-3 bg-orange add-cart-list-3 float-right"
                      @click="changeQtyProduct('plus')"
                    >
                      <img class="align-baseline position-relative" src="../../assets/img/icon/plus-2.png" width="15" style="top: 1px" />
                    </button>
                    <p
                      v-if="qtyCart > 0 && is_variant"
                      class="mb-0 body-2 text-green float-right mr-2 pt-1"
                      :class="{'mt-3':btn_design_type == '1','mt-2':btn_design_type == '2'}"
                    >({{qtyCart}}x)</p>
                  </template>
                </template>
                <button v-else @click="toggleDetail" class="btn bg-light border-form font-bold text-12 py-1 text-dark px-3 ls-1 float-right mt-3"
                >Not Yet Available</button>
              </div>
            </div>

            <!-- DELIVERY -->
            <template v-if="isDelivery && data.openTime.available">
              <div :id="`delivery-product-${data.id}`" class="border-green p-1 rounded body-3-1 position-absolute mb-0" style="right: 0px;top: 0px;">
                <img src="../../assets/img/icon/fast-delivery.png" width="20">
              </div>
              <b-tooltip :target="`delivery-product-${data.id}`" placement="top" title="Available for delivery">
              </b-tooltip>
            </template>
          </div>
		    </div>
		  </div>
		</template>

    <template v-if="design_type == '3'">
			<div class="d-block mb-2" :class="{'pr-2' : is_odd_index, 'pl-2': !is_odd_index}">
				<div class="w-100 position-relative h-150px">
					<img @click="toggleDetail" :src="data.image_url" :alt="data.name" class="img-fit radius-6" :class="{'grayscale' : !data.openTime.available}" />
          <template v-if="data.openTime.available">
            <p class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute mb-0" style="left: 10px;bottom: 10px;" v-if="is_variant">{{data.variant_list.length}} {{$pluralWord(data.variant_list.length,'variant')}}</p>
            <span v-if="is_decrease_promo" class="bg-green py-1 px-2 radius-12 body-3-1 position-absolute text-white" style="left:10px;top:10px;">-{{Math.floor(base_price.promotion_pct)}}%</span>
            <!-- DELIVERY -->
            <template v-if="isDelivery">
              <p :id="`delivery-product-${data.id}`" class="bg-white py-1 px-2 rounded body-3-1 position-absolute mb-0" style="right: 10px;top: 10px;">
                <img src="../../assets/img/icon/fast-delivery.png" width="24">
              </p>
              <b-tooltip :target="`delivery-product-${data.id}`" placement="top" title="Available for delivery">
              </b-tooltip>
            </template>
          </template>
				</div>
		    <div class="pt-2">
		    	<div class="w-100 mb-2" @click="toggleDetail">
			      <p class="mb-0 body-2-1 text-truncate">{{ data.name }}</p>
			        <p
			          class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1"
			           v-if="is_decrease_promo"
			        >{{ formatCurrency(promotion_price) }}</p>
			      	<p
			        	class="mb-0 body-2-1 text-orange d-inline-block align-middle"
			      >{{ formatCurrency(final_price) }}</p>
		    	</div>
          <template v-if="data.openTime.available">
            <div v-if="!getMerchant().is_preview_only" class="d-table w-100">
              <div class="text-right position-relative">
                <div v-if="!is_variant && qtyCart > 0" class="ml-auto" style="width: 120px;">
                  <div class="row no-gutters">
                    <div class="col-4 align-self-center">
                      <div class="pos-order-qty bg-orange" @click="changeQtyProduct('minus')">
                        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 1.71429H0V0H12V1.71429Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                    <div class="col-4 align-self-center text-center">
                      <p class="mb-0 font-lato text-14">{{ qtyCart  }}</p>
                    </div>
                    <div class="col-4 align-self-center">
                      <div class="pos-order-qty bg-orange ml-auto" @click="changeQtyProduct('plus')">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  v-if="btn_design_type == '1' && qtyCart == 0 && !is_variant"
                  class="ga-btn-primary-outline"
                  @click="changeQtyProduct('plus')"
                >{{ $t("restaurant.add-to-cart") }}</button>
                <button
                  v-if="btn_design_type == '1' && qtyCart == 0 && is_variant"
                  class="ga-btn-primary-outline"
                  @click="toggleVariant(false),toggleOpenVariant(true)"
                >{{ $t("restaurant.add-to-cart") }}</button>
                <button
                  v-if="qtyCart > 0 && is_variant"
                  class="ga-btn-primary"
                  @click="changeQtyProduct('plus')"
                >{{qtyCart}} Variant Selected</button>
              </div>
            </div>
          </template>
          <button 
            v-else
            @click="toggleDetail"
						class="g-btn g-btn-light g-btn-sm w-100" 
						>
						Not Yet Available
					</button>
		    </div>
			</div>
		</template>
    
		<template v-if="design_type == '4'">
			<div class="row slim-grid-row">
				<div class="col-12 position-relative">
          <template v-if="data.openTime.available">
            <p class="mb-0 badge-available body-3-3 text-white px-2" v-if="isDelivery">Available for Delivery</p>
            <p class="mb-0 badge-variant-2 body-3-3 text-white px-2" v-if="is_variant">{{data.variant_list.length}} {{$pluralWord(data.variant_list.length,'variant')}}</p>
          </template>
					<div class="row slim-grid-row justify-content-end">
						<div class="col-10" @click="toggleDetail">
					    <p class="mb-0 body-2 text-black text-truncate">{{ data.name }}</p>
					    <p v-if="data.description" class="mb-0 text-14 text-light-menu text-truncate">{{ data.description }}</p>
						</div>
						<div class="col-2">
							<p 
								v-if="qtyCart > 0 && is_variant"
					      class="mb-0 body-2-4 text-green"
					      :class="{'mt-3': data.description}"
					    >({{ qtyCart }}x)</p>
						</div>
					</div>
			    <div class="d-flex justify-content-between mt-2">
			      <div class="flex-shrink-0 pr-3" @click="toggleDetail">
			        <p
			          class="mb-0 ls-0-1 text-14 text-line-through d-inline-block text-light-menu mr-1"
			          v-if="is_decrease_promo"
			        >{{ formatCurrency(promotion_price) }}</p>
			        <p
			          class="mb-0 body-2-2 text-truncate font-semibold d-inline-block text-color-orange"
			          style="position: relative;top: 5px;"
			        >{{ formatCurrency(final_price) }}</p>
			      </div>
            <template v-if="data.openTime.available">
              <div v-if="!getMerchant().is_preview_only">
                <div v-if="!is_variant && qtyCart > 0" class="ml-auto" style="width: 120px;">
                  <div class="row no-gutters">
                    <div class="col-4 align-self-center">
                      <div class="pos-order-qty bg-orange" @click="changeQtyProduct('minus')">
                        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 1.71429H0V0H12V1.71429Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                    <div class="col-4 align-self-center text-center">
                      <p class="mb-0 font-lato text-14">{{ qtyCart  }}</p>
                    </div>
                    <div class="col-4 align-self-center">
                      <div class="pos-order-qty bg-orange ml-auto" @click="changeQtyProduct('plus')">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
  
                <button
                  v-if="btn_design_type == '1' && (qtyCart == 0 || is_variant)"
                  class="btn bg-orange font-bold text-12 py-1 text-white px-3 ls-1"
                  @click="changeQtyProduct('plus')"
                >{{ $t("restaurant.add-to-cart") }}</button>
                <button
                  v-if="btn_design_type == '2' && (qtyCart == 0 || is_variant)"
                  class="btn bg-orange add-cart-list-3"
                  @click="changeQtyProduct('plus')"
                >
                  <img src="../../assets/img/icon/plus-2.png" width="15" class="position-relative" style="top: -1px" />
                </button>
              </div>
            </template>
            <button
                v-else
                class="btn bg-light border-form font-bold text-12 py-1 text-dark px-3 ls-1"
                @click="toggleDetail"
              >Not Yet Available</button>
			    </div>
			  </div>
			</div>
		</template>

		<!-- POPUP DETAIL -->
		<popup-detail 
			:id_ref="data.id"
    	direction="bottom" 
    	:show="show_detail"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="!getMerchant().is_preview_only"
    	@close="toggleDetail">
    	<template v-slot:body>
    		<div class="py-3 px-3">

          <!-- IMAGE -->
    			<div class="w-100 position-relative mb-3">
    				<flickity ref="flickity"
    					v-if="data.image_list.length > 0"
              :options="$fullSliderOption">
              <div class="carousel-cell w-100" 
                v-for="img in data.image_list">
                <div style="height:270px;" class="w-100">
                  <img
                  	:alt="data.name" 
                  	:src="img.image_url"
                    class="img-fit radius-12"
                    :class="{'grayscale' : !data.openTime.available}">
                </div>
              </div>
            </flickity>
    				<div style="height:270px;" v-else>
		        	<img :alt="data.name" :src="data.image_url" :class="{'grayscale' : !data.openTime.available}" class="img-fit radius-12" />
		        </div>

		        <div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleDetail()">
							<img alt="close-icon" src="../../assets/img/icon/close.png" width="14" />
						</div>
						<span v-if="data.category != null" class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute" style="left:10px;bottom:10px;">{{data.category.name}}</span>
            
            <!-- DELIVERY -->
            <template v-if="isDelivery && data.openTime.available">
              <p :id="`delivery-detail-${data.id}`" class="bg-white py-1 px-2 rounded body-3-1 position-absolute mb-0" style="right: 10px;bottom: 10px;">
                <img src="../../assets/img/icon/fast-delivery.png" width="24">
              </p>
              <b-tooltip :target="`delivery-detail-${data.id}`" placement="top" title="Available for delivery">
              </b-tooltip>
            </template>
    			</div>
          
          <!-- NAME & PRICE -->
	        <p class="mb-0 body-1-2">{{data.name}}</p>
	        <div class="w-100 no-ws mb-3">
	        	<p 
							v-if="is_variant"
							:class="is_decrease_promo?'w-100' : 'd-inline-block align-middle mr-2'" 
							class="body-3 mb-0" >
							Starting from
						</p>

						<p 
							v-if="is_decrease_promo" 
							class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
							{{$formatCurrency(promotion_price)}}
						</p>
						<p 
							class="mb-0 body-1-4 text-green d-inline-block align-middle"
							:class="{
								'd-inline-block align-middle': is_decrease_promo
							}"
							>
							{{$formatCurrency(final_price)}}
						</p>
						<span v-if="is_decrease_promo" class="mb-0 font-bold text-green bg-green-light px-1 rounded-4 d-inline-block align-middle text-12 ml-2">-{{Math.floor(base_price.promotion_pct)}}%</span>
					</div>

          <!-- OPENING HOUR -->
          <div v-if="!data.openTime.available" class="w-100 p-2-5 rounded-4 mb-3 d-flex align-items-start" style="border-left: 3px solid #17a2b8; background-color: rgba(23, 162, 184, 0.05);">
            <div class="flex-shrink-0 mr-3">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.60701 10.4562C4.23622 10.4562 3.95813 10.1781 3.95813 9.80724C3.95813 9.44575 4.23622 9.16763 4.60701 9.16763H8.80614V3.55954C8.80614 3.19802 9.08425 2.91994 9.44574 2.91994C9.80724 2.91994 10.0946 3.19802 10.0946 3.55954V9.80724C10.0946 10.1781 9.80724 10.4562 9.44574 10.4562H4.60701ZM9.455 18.91C14.6275 18.91 18.91 14.6182 18.91 9.455C18.91 4.28257 14.6182 0 9.44574 0C4.28257 0 0 4.28257 0 9.455C0 14.6182 4.29184 18.91 9.455 18.91Z" fill="#17A2B8"/>
              </svg>
            </div>
            <div class="w-100 pt-1">
              <p class="body-2-4 mb-1">Available hour</p>
              <p class="body-3-1 mb-0" v-html="data.openTime.message"></p>
            </div>
          </div>
          
          <!-- DESCRIPTION -->
	        <div v-if="!(data.description == null || data.description == '')" class="html-desc body-2-2-1 mb-3" v-html="data.description">
					</div>

          <!-- VARIANT -->
          <template v-if="is_variant && getMerchant().is_preview_only && data.openTime.available">
            <hr class="my-3" />
            <p class="body-3-1 mb-2">Variant List</p>
            <template v-for="(variant,index) in data.variant_list">
              <menuItemVariant 
                @updateQty="updateVariantQty"
                :data="variant" 
                :product_cart_index="product_cart_index"></menuItemVariant>
            </template>
          </template>
    		</div>
    	</template>
    	<template v-if="!getMerchant().is_preview_only && data.openTime.available" v-slot:footer>
	    	<div class="px-3 pt-3" v-if="qtyCart == 0 && !is_variant">
		    	<button
		    	 	@click="changeQtyProduct('plus')" 
						class="ga-btn-primary-lg" >
						Select Product
					</button>
				</div>
				<template v-else>
					<div class="px-3 pt-3" v-if="is_variant">
			    	<button
			    	 	@click="toggleVariant(false)" 
							class="ga-btn-primary-lg" >
							 <span v-if="qtyCart == 0">Select Product</span>
							 <span v-else>{{qtyCart}} Variant Selected</span>
						</button>
					</div>
					<div class="row pt-2" v-else>
						<div class="col-12 text-center">
							<p class="body-3-1 mb-1">Selected Product</p>
						</div>
						<div class="col-4 offset-4 border-green py-2 radius-6">
							<div class="w-100">
								<div class="row no-gutters">
									<div class="col-4 align-self-center">
										<div class="pos-order-qty bg-orange" @click="changeQtyProduct('minus')">
											<svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M12 1.71429H0V0H12V1.71429Z" fill="white" />
											</svg>
										</div>
									</div>
									<div class="col-4 align-self-center text-center">
										<p class="mb-0 font-lato text-14">{{ qtyCart  }}</p>
									</div>
									<div class="col-4 align-self-center">
										<div class="pos-order-qty bg-orange ml-auto" @click="changeQtyProduct('plus')">
											<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
											</svg>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
	    </template>
    </popup-detail>
    <!-- END POPUP DETAIL -->

    <!-- VARIANTS -->
    <popup-detail 
			:id_ref="`${data.id}_variant`"
    	direction="bottom" 
    	:show="show_variant"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="true"
    	@close="toggleVariant(true),toggleOpenVariant(false)">

    	<template v-slot:body>
    		<div class="w-100 border-bottom p-3 position-relative">
    			<div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;">
						<img :alt="data.name" :src="data.image_url" class="img-fit radius-6">
					</div>
					<div class="d-inline-block align-middle w-75">
						<p class="mb-0 body-1-2">{{data.name}}</p>
						<p class="mb-0 body-2" v-if="data.category != null">{{data.category.name}}</p>
					</div>
					<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleVariant(true),toggleOpenVariant(false)">
						<img alt="close-icon" src="../../assets/img/icon/close.png" width="14" />
					</div>
    		</div>
    		<div class="p-3" :key="variant_detail_key">
    			<p class="body-3-1 mb-2">Variant List</p>
    			<template v-for="(variant,index) in data.variant_list">
    				<menuItemVariant 
    					@updateQty="updateVariantQty"
    					:data="variant" 
    					:product_cart_index="product_cart_index"></menuItemVariant>
    			</template>
    		</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
		    	<state-button
		    	 	:click="saveVariantChange" 
						size="lg"
						variant="primary"
						block >
						Save Change
					</state-button>
				</div>
			</template>
    </popup-detail>
    <!-- END VARIANT -->


		<!-- <menuDetail v-if="show_detail" :data="data" @done="toggleDetail" /> -->
	</div>
</template>
<script>
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex';
  import menuDetail from '@/components/restaurant-v2/menuDetail'
  import menuItemVariant from '@/components/restaurant-v2/menuItemVariant'

	export default{
		components:{
			menuDetail,
			menuItemVariant
		},
		props:{
			data:{
				type:Object,
				default: () => {}
			},
			design_type:{
				type:String,
				default: '0'
			},
			btn_design_type:{
				type: String,
				default: '1'
			},
			index:{
				type: Number,
				default: 0
			}
		},
		data(){
			return{
				show_detail: false,
				show_variant: false,
				variant_detail_key: 0,
				open_variant: false,
				variant_update: []
			}
		},
		computed:{
      is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      isDelivery(){
        if(!this.getMerchant().use_delivery) return false;
        if(!this.is_variant) return this.$isProductAllowDelivery(this.data);
        const isVariantHasDelivery = this.data.variant_list.some(variant => this.$isProductAllowDelivery(variant))
        return isVariantHasDelivery;
      },
      base_price(){
        return this.is_variant ? this.data.variant_list[0].price : this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? (this.base_price.price_sell_base) : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
      product_cart_index(){
      	return this.getRestaurantOrder().cart.findIndex(x=>x.product.data.product_id == this.data.product_id)
      },
      qtyCart(){
        let data = 0
        if(this.product_cart_index != -1){
          data = this.getRestaurantOrder().cart[this.product_cart_index].qty
        }

        return data
      },
      is_odd_index(){
    		return (this.index+1)%2 == 1 ? true : false
      },
    },
    methods:{
      ...mapGetters(['getMerchant','getRestaurantOrder']),
      ...mapMutations(['setRestaurantOrder','removeRestaurantOrder']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      toggleDetail(){
        this.show_detail = !this.show_detail
      },
      closePopup(){
        this.show_popup = false
      },
      changeQtyProduct(type){
        if(type == 'plus' && this.is_variant){
          this.toggleDetail()
        }else{
          let params = {
            product: this.data,
            variant: {},
            qty: this.qtyCart
          }
          if(this.qtyCart == 1 && type == 'minus'){
            this.removeRestaurantOrder(params)
          }else{
            if(type == 'minus'){
              params.qty--
            }else{
              params.qty++
            }
            this.setRestaurantOrder(params)
          }
        }
      },
      toggleOpenVariant(action){
      	this.open_variant = action
      },
      toggleVariant(action){
      	if (action == true) {
      		this.show_variant = false
      		this.variant_update = []
      	}else{
      		this.show_variant = true
      		if(this.product_cart_index != -1){
      			let variant_cart = this.getRestaurantOrder().cart[this.product_cart_index].variant
						this.variant_update = variant_cart.map(el=>{
							delete el.notes
							return el
						})
      		}
      	}
      	if (!this.open_variant) {
      		this.show_detail = action
      	}
      },
      updateVariantQty(variant){
      	let variant_i = this.variant_update.findIndex(x=>x.data.product_ga_pos_id == variant.data.product_ga_pos_id)
      	if(variant_i != -1){
      		if(variant.qty <= 0){
      			this.variant_update.splice(variant_i,1)
      		}else{
      			this.variant_update.splice(variant_i,1,variant)
      		}
      	}else{
      		this.variant_update.push(variant)
      	}
      },
      saveVariantChange(){
      	return new Promise((success,fail)=>{
      		if(this.product_cart_index == -1 && this.variant_update.length == 0){
      			console.log("none")
      			this.toggleVariant(true)
      			success()
      		}else{
      			let params = this.product_cart_index != -1 ? this.variant_update.length == 0 ? 'delete' : 'push_delete' : 'push'
      			this.updateVariantToVuex(params).then(()=>{
      				console.log("done")
      				this.toggleVariant(true)
      				success()
      			})
      		}
      	})
      },
      updateVariantToVuex(action){
      	return new Promise((success,fail)=>{
	    		if(action == 'push'){
	    			this.variant_update.forEach((item,index)=>{
		      		let params = {
		            product: this.data,
		            variant: item.data,
		            qty: item.qty
		          }
		          this.setRestaurantOrder(params)
		          if(index+1 == this.variant_update.length){
		          	console.log("push")
		          	success()
		          }
		      	})
	    		}else if(action == 'delete'){
	    			let variant_cart = this.$deepCopy(this.getRestaurantOrder().cart[this.product_cart_index].variant)
	    			variant_cart.forEach((item,index)=>{
	    				let params = {
		            product: this.data,
		            variant: item.data
		          }
		          this.removeRestaurantOrder(params)
		          if(this.product_cart_index == -1){
		          	console.log("delete")
		          	success()
		          }
	    			})
	    		}else{
	    			this.variant_update.forEach((item,index)=>{
		      		let params = {
		            product: this.data,
		            variant: item.data,
		            qty: item.qty
		          }
		          this.setRestaurantOrder(params)
		          if(index+1 == this.variant_update.length){
		          	let diff = this.getRestaurantOrder().cart[this.product_cart_index].variant.filter(x=> !this.variant_update.some(y=>x.data.id == y.data.id))
		          	diff.forEach((item_diff,index_diff)=>{
		          		let params_diff = {
				            product: this.data,
				            variant: item_diff.data
				          }
				          this.removeRestaurantOrder(params_diff)
				          if(index_diff+1 == diff.length){
				          	console.log("push_delete")
				          	success()
				          }
		          	})
		          	if(diff.length == 0){
		          		console.log("other")
		          		success()
		          	}
		          }
		      	})
	    		}
      	})
      }
    }
	}
</script>
<style scoped>
	.badge-variant{
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #000000b5;
    border-radius: 0px 0px 10px 10px;
    width: 100%;
    text-align: center;
  }
  .badge-variant-2{
    position: absolute;
    top: -16px;
    right: 0px;
    background-color: #000000b5;
    border-radius: 0px 3px 0px 0px;
    display:table;
    text-align: center;
  }
  .badge-available{
    position: absolute;
    top: -16px;
    left: 0px;
    background-color: #000000b5;
    border-radius: 3px 0px 0px 0px;
    display:table;
    text-align: center;
  }
	.img-list-2 {
    height: 92px;
  }

  .text-black {
	  color: #000 !important;
	}

	.img-list-3 {
	  height: 190px;
	}

  .object-fit {
    object-fit: cover;
  }

  .img-crement {
    padding: 7px;
    border-radius: 5px;
  }

  .height-70 {
    height: 50px;
  }

  .add-cart-list {
    padding: 6px 24px !important;
  }

  .menu-list-desc {
    height: 65px;
    overflow: hidden;
  }

  .text-light-menu {
    color: #9ba1aa;
  }

  .add-cart-list-3 {
    border-radius: 6px;
    padding: 4px 8px;
    box-shadow: 4px 4px 10px 0px #dadadac4;
  }

  .add-cart-text-list {
	  padding: 4px 8px;
	  margin-top: 5px;
	  border-radius: 6px;
	  box-shadow: 4px 4px 10px 0px #dadadac4;
	}

	.plus-min-text-list {
	  position: relative;
	  left: 0px;
	  top: 0px;
	  margin-right: -15px;
	}

  @media screen and (max-width: 600px) {
    .plus-min-set {
      margin-left: -20px;
    }

    .top-menu-list {
      top: 0 !important;
    }
  }

  @media screen and (max-width: 655px) {
    .img-height-menu {
      height: 153px !important;
    }

    .top-menu-list {
      top: 0 !important;
    }

    .menu-list-desc {
      height: 42px;
      overflow: hidden;
    }

    .add-cart-list {
      margin-top: 8px;
    }

    .add-note-list {
      position: relative;
    }

    .add-note-list-2 {
      margin-top: -25px !important;
      position: absolute;
    }

    .img-list-2 {
      height: 65px !important;
    }

    .plus-min-text-list {
	    left: -10px !important;
	    top: 10px !important;
	  }

	  .img-list-3 {
      height: 129px !important;
    }

  }

  @media screen and (max-width: 655px) {
    .plus-min-list-2 {
      margin-left: -45px !important;
    }

    .plus-min-list-2 input {
      width: 25px !important;
    }
  }
  .h-150px{
  	height: 150px;
  }
	.pos-order-qty {
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/restaurant-v2/menuItem.vue